// bare minimum, non-functional Symbol "polyfill" to make lit-html AttributeCommitter work. (lit-html/src/lib/parts/ts)
if (typeof Symbol === 'undefined') {
	(window as any).Symbol = { iterator: 'not implemented Symbol.iterator' };
}
